const ITEMS = [
    "CHERRY BLOSSOM GIFTS",
    "PERSONALIZED MUGS · R100",
    "RAMADHAAN GIFT SETS",
    "MASON JARS · R130",
    "NATIONWIDE · PUDO & PAXI & THE COURIER GUY",
];

export const Marquee = () => (
    <div
        className="marquee-band relative overflow-hidden border-y border-sky-300 bg-sky-50 py-5"
        data-testid="editorial-marquee"
    >
        <div className="marquee-track">
            {[0, 1].map((copy) => (
                <div
                    className="flex items-center shrink-0"
                    aria-hidden={copy === 1}
                    key={copy}
                >
                    {ITEMS.map((text, i) => (
                        <span
                            key={i}
                            className="flex items-center whitespace-nowrap font-display text-xl md:text-2xl font-medium tracking-wide text-sakura-800"
                        >
                            <span className="mx-6 md:mx-10 inline-block h-2.5 w-4 rotate-45 rounded-full bg-sakura-500" />
                            {text}
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);

export default Marquee;
